import { render, staticRenderFns } from "./vin-recall.vue?vue&type=template&id=477832b0"
import script from "./vin-recall.vue?vue&type=script&lang=js"
export * from "./vin-recall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports